export default "__VITE_ASSET__BLsevYUJ__"